import { clone } from "ramda";
import { LoginState } from "src/login/reducer";

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (errpr) {
    return undefined;
  }
};

export const saveState = (state: { user: LoginState }) => {
  try {
    const newState = clone(state);
    newState.user.user.errorMessage = "";
    const serializedState = JSON.stringify(newState);
    localStorage.setItem("state", serializedState);
  } catch (err) {
    // Ignore write errors, we just won't have a persisted state
  }
};

export const saveRedirectUrl = (redirectUrl: string) => {
  try {
    localStorage.setItem("redirectUrl", redirectUrl);
  } catch (err) {
    // Ignore write errors, we just won't have a persisted state
  }
};

export const loadRedirectUrl = () => {
  try {
    const redirectUrl = localStorage.getItem("redirectUrl");
    if (redirectUrl == null) {
      return "";
    }
    return redirectUrl;
  } catch (error) {
    return "";
  }
};

export const getAccessToken = () => {
  const serializedState = loadState();
  if (serializedState) {
    return serializedState.user.user.credentials.accessToken;
  } else {
    return "";
  }
};

export const getTokenType = () => {
  const serializedState = loadState();
  if (serializedState) {
    return serializedState.user.user.credentials.tokenType;
  } else {
    return "";
  }
};

export const getOrganization = () => {
  return localStorage.getItem("org");
};

export const setUrlToRedirectAfterLogout = (endpoint: string) => {
  return localStorage.setItem("redirectTo", endpoint);
};

export const getUrlToRedirectAfterLogout = () => {
  return localStorage.getItem("redirectTo");
};

export const isRetryRequired = () => {
  const serializedState = loadState();
  if (!serializedState) {
    return;
  }
  const credentials = serializedState.user.user.credentials;
  const currentTime = new Date().getTime();
  const issuedAt = parseInt(credentials.issuedAt || "0", 10);
  const lastUsed = parseInt(credentials.lastUsed || "0", 10);
  const apiDuration = parseInt(credentials.expiresIn || "0", 10) * 1000;
  return (
    issuedAt + apiDuration < currentTime && lastUsed + apiDuration > currentTime
  );
};

export const setDirty = token => {
  localStorage.setItem("dirty", JSON.stringify(token));
};

export const unsetDirty = () => {
  localStorage.setItem("dirty", "");
};



// WEBPACK FOOTER //
// ./src/route/LocalStorage.tsx